import { render, staticRenderFns } from "./permisosAdministrador.vue?vue&type=template&id=136d9f04&"
import script from "./permisosAdministrador.vue?vue&type=script&lang=js&"
export * from "./permisosAdministrador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports